import { useNavigate, useParams } from 'react-router';
import { ScreenSkeleton } from '../../../components/atoms/ScreenSkeleton';
import { Button } from '../../../components/atoms/Button';
import { ScreenHeading } from '../../../components/molecules/ScreenHeading';
import PhotoSelector from '../../../components/atoms/PhotoSelector';
import { ArrowLeft } from 'lucide-react';
import { ObservableItemIdentifier } from '../../../api-contracts/other/ObservableItemIdentifier';
import { useAssetMineLocationLevel } from '../../../hooks/useAssetMineLocationLevel';
import { ErrorBanner } from '../../../components/atoms/ErrorBanner';
import useInspectionCategoryType from '../../../hooks/useInspectionCategoryType';
import { ScreenObservationLayout } from '../../../components/templates/ScreenObservationLayout';
import { observationService } from '../../../services/observationService';

export const MachinePhotoScreen = () => {
  const { externalId } = useParams();
  const navigate = useNavigate();

  const assetMineLocationState = useAssetMineLocationLevel({
    inspectionId: externalId,
  });

  const inspectionCategoryType = useInspectionCategoryType({
    inspectionId: externalId,
  });

  if (assetMineLocationState.isLoading) {
    return <ScreenSkeleton fields={4} />;
  }

  if (assetMineLocationState.error) {
    return <ErrorBanner message={assetMineLocationState.error} />;
  }

  return (
    <div>
      <ScreenHeading
        eyebrow={'Operation hours'}
        title={'Machine'}
        tooltipKey={'operating-hours-screen-header'}
      />

      <ScreenObservationLayout>
        <div className="mt-4"></div>

        <PhotoSelector
          title="Photo"
          isMultiple={false}
          path={ObservableItemIdentifier.Identifiers.CoverPhoto.Photo}
          dataLevel={assetMineLocationState.observableLevelsEnum}
          entityId={assetMineLocationState.entityId}
          entityExternalId={assetMineLocationState.entityExternalId}
          inspectionId={externalId ?? ''}
          inspectionCategoryTypeId={inspectionCategoryType?.externalId ?? ''}
        />
        {/* </div> */}

        <div className="mt-2 flex items-center justify-center p-4">
          <Button
            variant="primary"
            prefixIcon={<ArrowLeft color="white" />}
            onClick={async () => {
              await observationService.upsertObservation({
                inspectionId: externalId ?? '',
                inspectionCategoryId: inspectionCategoryType?.externalId ?? '',
                dataLevel: assetMineLocationState.observableLevelsEnum,
                entityId: assetMineLocationState.entityId,
                entityExternalId: assetMineLocationState.entityExternalId,
                path: ObservableItemIdentifier.Identifiers.CoverPhoto.Completed,
                value: new Date().toISOString(),
              });

              navigate(-1);
            }}
          >
            Mark as complete
          </Button>
        </div>
      </ScreenObservationLayout>
    </div>
  );
};
